(function (app) {
    app.config([
        "paginationTemplateProvider", function (paginationTemplateProvider) {
            paginationTemplateProvider.setPath('App/Components/DirPaginationControls/dirPagination.tpl.html');
        }]);
})(window.app);

//ng-file-upload.js Documentation: https://github.com/danialfarid/ng-file-upload/blob/master/README.md#full-reference